import { MapAction } from '../map-action';
import * as mapboxgl from 'mapbox-gl';

export abstract class LayerAction extends MapAction {

  abstract listen(mapbox: mapboxgl.Map, layerName: string): void;
}
